var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangleDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6335_21254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2119 2C11.4957 2.00201 11.775 2.07216 12.027 2.20474C12.2791 2.33731 12.4967 2.52855 12.6622 2.76286C12.8277 2.99717 12.9363 3.26792 12.9793 3.55302C13.0222 3.83812 12.9982 4.12949 12.9093 4.40339L12.8685 4.51624L12.8313 4.5931L8.57571 12.0552C8.42552 12.3314 8.2076 12.5634 7.94311 12.7287C7.67863 12.8941 7.37657 12.9871 7.06628 12.9987C6.75598 13.0104 6.44799 12.9403 6.17221 12.7953C5.89643 12.6503 5.66224 12.4353 5.49238 12.1711L5.43056 12.0656L1.16899 4.5931L1.13237 4.51685C1.02428 4.2464 0.981416 3.95359 1.00736 3.66288C1.03331 3.37216 1.12731 3.09197 1.28151 2.8457C1.43572 2.59942 1.64566 2.39422 1.89381 2.2472C2.14195 2.10019 2.4211 2.01564 2.70795 2.00061L2.74277 2L2.77878 2.00122L2.80459 2H11.2119Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6335_21254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDown);
export default __webpack_public_path__ + "static/media/triangle_down.972d9b9b22581e3654dba4288aa3e7de.svg";
export { ForwardRef as ReactComponent };